import { STATE_CHART_ICON_MAPPING, EVENT_ICON_MAPPING } from './constants';

// These errors use same icon, put them into one array
const OtherErrors = ['VPF', 'EBVS', 'VSF'];

/**
 * Use this function to find right icon type of an event,
 * we have many different event types definied in backend
 * (backend doc: https://beacon.corp.conviva.com/display/dev/Timeline+in+Pulse+API+for+Pulse+5+UI+%3C%3E+Metrics+Gateway -> Value types for Events)
 * so we must get different types of icon by them(string, object).
 * @param eventValue
 */

export const getEventBackground = eventValue => {
  const typeOfValue = typeof eventValue;
  let iconType = '';
  if (typeOfValue === 'string') {
    iconType = eventValue;
  } else if (typeOfValue === 'object') {
    const { type } = eventValue;
    iconType = type;
  }

  return EVENT_ICON_MAPPING[iconType.replace(/\s/g, '')];
};

export const getStateBackground = stateValue => STATE_CHART_ICON_MAPPING[stateValue.replace(/\s/g, '')];
